import { createSelector } from '@ngrx/store';
import { IAppState } from '..';

const CoreStore = (state: IAppState) => state.core;

export const CoreSelectors = {
  isDesktop: createSelector(CoreStore, (state) => state.isDesktop),
};
